<div class="ac-page c7-access-view c7-access-login">

  <header class="ac-topbar">
    <div class="ac-topbar__inner">
      <a class="ac-brand" href="javascript:void(0)" aria-label="CULTURA">
        <img src="assets/logo-blue.png" alt="CULTURA" class="ac-brand__logo" />
      </a>
      <label class="ac-lang">
        <span>{{ "acceptPage.language" | translate }}</span>
        <select [value]="selectedLanguage" (change)="changeLanguage($any($event.target).value)">
          <option *ngFor="let language of supportedLanguages" [value]="language.code">{{ language.name }}</option>
        </select>
      </label>
    </div>
  </header>

  <main class="ac-main ac-main--center">
    <section class="ac-card ac-card--single" aria-labelledby="ac-login-title">
      <div class="ac-card__head">
        <h2 id="ac-login-title">{{ "login.signin" | translate }}</h2>
        <p class="ac-card__sub">{{ "login.stayConnected" | translate }}</p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="login()" novalidate class="ac-form">

        <div class="ac-field">
          <label for="ac-email">{{ "form.email" | translate }}</label>
          <input id="ac-email" type="email" formControlName="email" autocomplete="username"
            [attr.aria-invalid]="(submitted || f['email'].touched) && f['email'].invalid ? 'true' : 'false'" />
          <span class="ac-error" *ngIf="(submitted || f['email'].touched) && f['email'].hasError('required')" aria-live="polite">
            {{ "login.form.email.error.required" | translate }}
          </span>
          <span class="ac-error" *ngIf="submitted && f['email'].hasError('email')" aria-live="polite">
            {{ "login.form.email.error.email" | translate }}
          </span>
        </div>

        <div class="ac-field">
          <label for="ac-password">{{ "form.password" | translate }}</label>
          <div class="ac-input-wrap">
            <input id="ac-password" [type]="showPassword ? 'text' : 'password'" formControlName="password"
              autocomplete="current-password"
              [attr.aria-invalid]="(submitted || f['password'].touched) && f['password'].invalid ? 'true' : 'false'" />
            <button type="button" class="ac-toggle" (click)="togglePasswordVisibility()"
              [attr.aria-label]="(showPassword ? 'acceptPage.hidePassword' : 'acceptPage.showPassword') | translate">
              <img [src]="showPassword ? 'assets/eye-slash.svg' : 'assets/eye.svg'" alt="" />
            </button>
          </div>
          <span class="ac-error" *ngIf="(submitted || f['password'].touched) && f['password'].hasError('required')" aria-live="polite">
            {{ "login.form.password.error.required" | translate }}
          </span>
          <span class="ac-error" *ngIf="submitted && f['password'].hasError('minlength')" aria-live="polite">
            {{ "login.form.password.error.pass" | translate }}
          </span>
        </div>

        <div class="ac-links">
          <a [routerLink]="['/reset-password']">{{ "login.form.forgotPassword" | translate }}</a>
        </div>

        <button class="ac-btn" type="submit" [disabled]="isLoading">
          {{ (isLoading ? "login.form.submitting" : "login.form.submit") | translate }}
        </button>
        <p class="ac-error ac-error--block" *ngIf="errormsg" role="alert">{{ errormsg | translate }}</p>
      </form>

      <hr class="ac-card__divider" />
      <p class="ac-card__alt">
        {{ "contactPage.loginHint" | translate }}
        <a [routerLink]="['/contact']">{{ "contactPage.loginLink" | translate }}</a>
      </p>
    </section>
  </main>

  <app-auth-footer></app-auth-footer>
</div>
